export const testIds247: string[] = [
  '62a1cb01eb55ba12abdcaa13',
  '62a1cb01eb55ba1363dcaa12',
  '62f521c604e067ae63db6612'];

export const is247Test = (testId: string) => {
  return testIds247.includes(testId);
};

export const testId247Text = '24 / 7';

export const covidTestsOrder = [
  'COVID-19 PCR Стандарт',
  'COVID-19 PCR Експрес',
  'COVID-19 PCR - слюнка',
  'COVID-19 - PCR Pool test',
  'COVID-19 - RAT',
  'COVID-19 (anti-SARS-CoV2 IgG Ab) Immunity',
  'COVID-19  T-SPOT'
];

export const firstCategoryId = '62a1cb01eb55ba2e51dcaa3e';

// subCategories
export const bioCategoryId = '63483191c9c7496b47bee218';

export const covidSubCategoryId = '63483191c9c749c94cbee139';
export const spermAnalysisSubCategory = '63483191c9c7496d2cbee199'
